import { memo } from "react";
import { StyleSheet } from "react-native";
import OpacityView from "src/components/OpacityView";
import PillButton from "src/components/PillButton";
import useHamburgerNav from "src/hooks/useHamburgerNav";
import IconClose from "src/icons/IconClose";
import { paddingLarge } from "src/styles/spacing";
import { AnimatePresence, useSafeArea } from "src/swsh-native";
import usePhotoDetailStore from "../../stores/usePhotoDetailStore";
import PhotoDetailRegularUI from "./components/PhotoDetailRegularUI";
import PhotoLoading from "./components/PhotoLoading";

const PhotoDetailUI = () => {
	useHamburgerNav(false);
	const mode = usePhotoDetailStore((state) => state.mode);
	const safeArea = useSafeArea();
	const setMode = usePhotoDetailStore((state) => state.setMode);
	const disableZoomMode = () => setMode("Regular");

	return (
		<AnimatePresence>
			{(() => {
				switch (mode) {
					case "Zoom":
						return (
							<OpacityView
								key="Zoom"
								style={styles.container}
								pointerEvents="box-none"
							>
								<PillButton
									Icon={IconClose}
									onPress={disableZoomMode}
									blur
									containerStyle={{
										position: "absolute",
										top: safeArea.top + paddingLarge,
										right: paddingLarge,
									}}
								/>
							</OpacityView>
						);
					case "Regular":
						return (
							<OpacityView
								key="Regular"
								style={styles.container}
								pointerEvents="box-none"
							>
								<PhotoDetailRegularUI />
							</OpacityView>
						);
					case "Carousel":
						return (
							<OpacityView
								key="Carousel"
								style={styles.container}
								pointerEvents="box-none"
							>
								<PhotoLoading
									style={{
										position: "absolute",
										top: safeArea.top + paddingLarge,
										right: paddingLarge,
									}}
								/>
							</OpacityView>
						);
					case "FullScreen":
					default:
						return null;
				}
			})()}
		</AnimatePresence>
	);
};

const styles = StyleSheet.create({
	container: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: 2,
	},
});

export default memo(PhotoDetailUI);
